import Disclaimer from "../../../../contents/docs/self-host/deploy/snippets/disclaimer";
import * as React from 'react';
export default {
  Disclaimer,
  React
};